import CountryBeanContactPerson from "./../images/caseStudy/countryBeans/poc.png";
import CountryBeanHeroImage from "./../images/caseStudy/countryBeans/hero.png";
import CountryBeanLogo from "./../images/caseStudy/countryBeans/logo.jpeg";

import GynovedaContactPerson from "./../images/caseStudy/gynoveda/poc.jpeg";
import GynovedaHeroImage from "./../images/caseStudy/gynoveda/hero.jpeg";
import GynovedaBrandLogo from "./../images/customers/gynoveda-logo.svg";

import KanelleContactPerson from "./../images/caseStudy/kanelle/poc.jpeg";
import KanelleHeroImage from "./../images/caseStudy/kanelle/hero.png";
import KanelleBrandLogo from "./../images/caseStudy/kanelle/logo.png";

const caseStudyList = {
  caseStudyList: {
    gynoveda: {
      id: "gynoveda",
      company: "Gynoveda",
      title: "Gynoveda sees over 15X conversions after partnering with Growlytics",
      about: "Gynoveda is an ayurveda healthtech startup with a vision to combine Content, Technology, Ayurveda medicines ready-to-buy online for women to experience healthy periods, lifelong!",
      image: GynovedaHeroImage,
      logo: GynovedaBrandLogo,
      niche: "Health Care",
      industry: "D2C",
      description: "Find out how Gynoveda was able to integrate its 3 business units with Growlytics using an Insights-led Omnichannel approach to engagement, thereby resulting in an overall uplift in performance",
      teasor: {
        description: "Gynoveda was able to provide personalized onboarding to all their buyers and was able to track progress of their health after buying poducts.",
        background: "rgb(76 7 21 / 8%)",
      },
      keyResults: [
        {
          number: "2X",
          title: "Uplift in overall revenue",
        },
        {
          number: "15%",
          title: "Increase in Cart Recovery",
        },
        {
          number: "5X",
          title: "Increase in Repeat Purchases",
        },
      ],
      testimonial: {
        name: "Vishal Gupta",
        image: GynovedaContactPerson,
        designation: "CEO, Gynoveda",
        description: "Growlytics has been quite satisfactory for our customer experience needs. Using Growlytics, we have witnessed an adequate jump in our cart recovery and repeat orders.",
      },
      study: {
        challenge: {
          description: "Gynoveda wanted to provide personalized onboarding to all their buyers and wnated to track progress of the health after buying poducts. Gynoveda also wanted to implement product specific conversion and retention strategies.",
          list: [
            { title: "Product based personalized onboarding", description: "Based on product purchased, gynoveda wanted to connect consumers with doctors and track the progress of consumers after using their products." }, //
            { title: "Increase in abandoned cart recovery", description: "Gynoveda was looking to boost abandoned cart recovery with omni-channel product based followups." },
            { title: "Product specific retention strategies", description: "Having less number of products, gynoveda wanted to keep the retention strategies different for different products purchased." },
            { title: "Deep Integration Options With Shopify", description: "Need to sync all customer data, activities, purchase histories and after sales activities like orders being delivered/cancelled etc. to provide personalized communication." },
          ],
        },
        solution: [
          "Needless to say, Gynoveda was looking for all-in-one marketing automation solution which can provide both omni-channel marketing with Customer Data Platform.",
          "Using Growlytics platform, Gynoveda employed a four-fold strategy to remedy Gynoveda’s data, sales and e-commerce optimization challenges. This was acheived by crunching analytics through  Growlytics's deep integration with Shopify platform. With Growlytics's omni-channel marketing capablity, and advanced marketing automation journeys, Gynovea was easily able to acheive the goal of personalized onboarding, abandoned cart conversions retention strategies and much more.", //
        ],
        impact: [],
      },
    },

    "country-beans": {
      id: "country-beans",
      company: "Country Bean",
      title: "Country Bean sees a 40% increase in purchase orders within six months",
      about: "Country Bean is a coffee brand that sells instant and filter coffee, as well as drinkware, hot chocolate, and other items both offline and online.",
      image: CountryBeanHeroImage,
      logo: CountryBeanLogo,
      niche: "Food & Beverages",
      industry: "D2C",
      description: "Find out how Country Beans, one of the leading coffee brands in India used Growlytics Journeys to increase customer engagement and tackle customer drop-offs, leading to a boost in app conversions from 35% to 75%.",
      teasor: {
        description: "Country Bean was able to design a variety of journeys and campaigns with goal to personalize the engagement to each of their customers. ",
        background: "rgb(253 243 231)",
      },
      keyResults: [
        {
          number: "2X",
          title: "Uplift in overall revenue",
        },
        {
          number: "15%",
          title: "Increase in Cart Recovery",
        },
        {
          number: "5X",
          title: "Increase in Repeat Purchases",
        },
      ],
      testimonial: {
        name: "Dhwani Bhuwalka",
        image: CountryBeanContactPerson,
        designation: "Marketing Manager, CountryBean",
        description: "Growlytics has been an integral part of our conersion and retention strategies. We do take into consideration how we are going to leverage Growlytics as a platform to further drive our customer retention and acquisition.",
      },
      study: {
        challenge: {
          description: "",
          list: [
            { title: "Provide premium coffee buying experience", description: "" }, //
            { title: "To Increase abandoend cart increase user engagement", description: "" },
            { title: "Increasing repeat orders", description: "" },
            { title: "To track customer behaviour and boost user retention rate", description: "" },
            { title: "Increase conversion and return on investment (ROI)", description: "" },
          ],
        },
        solution: [
          "Country Bean was able to design a variety of journeys and campaigns with goal to personalize the engagement to each of their customers. Growlytics Consumer Success team helped country bean create numerous Journeys in order to boost conversions and monitor customer inactivity to retain customers. These Journeys help Country Bean keep track of where each consumer is in the funnel as they move from subscribing to placing an order.",
          //
        ],
        impact: [],
      },
    },

    kanelle: {
      id: "kanelle",
      company: "Kanelle",
      title: "Kanelle drove 40% of online revenue using a data driven omnichannel approach",
      about: "Kanelle is a leading online fashion label in india selling crafted premium clothes for women, both offline and online.",
      image: KanelleHeroImage,
      logo: KanelleBrandLogo,
      niche: "Fashion",
      industry: "D2C",
      description: "Kanelle unites email, SMS and WhatsApp in a single dashboard for a more engaging customer experience that drives nearly 40% of all revenue.",
      teasor: {
        description: "Kanelle was able to implement their purchase funnel-based end-to-end customer engagement strategy with pro-active retention strategies and reduce abandoned cart drop-offs.",
        background: "rgb(108 42 38 / 9%)",
      },
      keyResults: [
        {
          number: "2X",
          title: "Uplift in overall revenue",
        },
        {
          number: "15%",
          title: "Increase in Cart Recovery",
        },
        {
          number: "5X",
          title: "Increase in Repeat Purchases",
        },
      ],
      testimonial: {
        name: "Aditya Sibal",
        image: KanelleContactPerson,
        designation: "Founder, Kanelle",
        description: "Growlytics lets us experiment with what channel works best for different audiences and different messages.",
      },
      study: {
        challenge: {
          description: "",

          // Creating up a series of triggered and automated campaigns that convert well
          // Setting up customer engagement strategy across multiple channels and touchpoints
          list: [
            { title: "Providing luxury buying experience", description: "" }, //
            { title: "Lack of an unified, clutter-free omni-channel marketing solution", description: "" }, //
            { title: "Poor conversion rates compared to website visits", description: "" },
            { title: "Understanding customer behavior – reading cohorts on repeat purchases, retention rates, etc.", description: "" },
          ],
        },
        solution: [
          "Using the Growlytics, kanelle team decided to implement their purchase funnel-based end-to-end customer engagement strategy to provide personalized buying experience,implement pro-active retention strategies and reduce abandoned cart drop-offs.  This involved Funnel Segmentation, Personalized Engagement & Omni-channel journey campaigns.",
          //
        ],
        impact: [],
      },
    },
  },
};

export default caseStudyList;
